var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highliter',{staticClass:"el-dynamic",attrs:{"value":"Post Categories","hide-add":"","hide-right":""}},[_c('div',{staticClass:"post-categories"},[_vm._v(" Sport ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }